export function init(setup, { onReady, onOffline, onStatusChange }) {
  window.Twilio.Device.setup(setup.token, {
    enableRingingState: true,
    closeProtection: true,
    warnings: true
  });

  window.Twilio.Device.ready(onReady);

  /**
   * This happens when connection to Twilio drops or the device's capability token is invalid/expired.
   * Probably, need to get token again and instantiate Twilio from scratch.
   */
  window.Twilio.Device.offline(onOffline);

  window.Twilio.Device.disconnect(cn => {
    onStatusChange(cn.status());
  });
  window.Twilio.Device.error(err => {
    onStatusChange(err.connection.status());
  });
  window.Twilio.Device.connect(cn => {
    onStatusChange(cn.status());
  });

  return {
    end: () => window.Twilio.Device.disconnectAll(),
    start: () => {
      const cn = window.Twilio.Device.connect({
        phone_number: setup.phone_number,
        booking_id: setup.booking_id
      });

      onStatusChange(cn.status());
    }
  };
}

export const teardown = () => window.Twilio.Device.destroy();



// WEBPACK FOOTER //
// ./src/core/integrations/twilio/index.js